import { render, staticRenderFns } from "./IRCDashboard.vue?vue&type=template&id=fd513324&scoped=true"
import script from "./IRCDashboard.vue?vue&type=script&lang=js"
export * from "./IRCDashboard.vue?vue&type=script&lang=js"
import style0 from "./IRCDashboard.vue?vue&type=style&index=0&id=fd513324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd513324",
  null
  
)

export default component.exports